import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-no-smart-meter",
  templateUrl: "./no-smart-meter.component.html",
  styleUrls: ["./no-smart-meter.component.scss"],
})
export class NoSmartMeterComponent implements OnInit {
  customerServiceNumber: string;
  
  constructor(private generalService: GeneralService) {}

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/no-smart-meter/no-smart-meter.component.ts